import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';

import { IApplicationState } from '../types/redux';
import { TThunkDispatch } from '../types/redux';

export const useAppDispatch = (): TThunkDispatch => useDispatch<TThunkDispatch>();
export const useAppSelector: TypedUseSelectorHook<IApplicationState> = useSelector;
